import {
	request
} from '@/js_sdk/request.utils.js';

export function userFile(data) {
	return request({
		url: '/api/uploadFile/userFile',
		method: 'POST',
		data,
		app4Token:true
	})
}

export function uploadUserDevice(data) {
	return request({
		url: '/api/user/uploadDeviceInfo',
		method: 'POST',
		data
	})
}
